import { gsap, Quad } from "gsap"; // Also works with TweenLite and TimelineLite
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

const animation = {
  staggeredFadeInUp: function (staggerElem, triggerElement) {
    let tlStaggerUp = gsap.timeline({
      scrollTrigger: {
        trigger: triggerElement,
        start: "top 60%",
      },
    });
    tlStaggerUp.staggerFromTo(
      staggerElem,
      1,
      {
        autoAlpha: 0,
        y: 40,
      },
      { autoAlpha: 1, y: 0, ease: Quad.easeOut },
      0.2
    );
  },
  slideInUp: function (elm) {
    let tlStaggerUp = gsap.timeline({
      scrollTrigger: {
        trigger: elm,
        start: "top 80%",
      },
    });
    tlStaggerUp.fromTo(
      elm,
      1,
      {
        yPercent: 100,
      },
      { yPercent: 0, ease: Quad.easeOut }
    );
  },
  fadeInUp: function (elm) {
    let tlStaggerUp = gsap.timeline({
      scrollTrigger: {
        trigger: elm,
        start: "top 80%",
      },
    });
    tlStaggerUp.fromTo(
      elm,
      1,
      {
        autoAlpha: 0,
        y: 30,
      },
      {
        autoAlpha: 1,
        y: 0, 
        ease: Quad.easeOut 
      }
    );
  },
};

if (window.theme.showElementStaggering) {
  let animeContainer = document.querySelectorAll("[data-stagger-wrap]");

  animeContainer.forEach(function (item, index) {
    let staggerElem = item.querySelectorAll("[data-animate]");
    animation.staggeredFadeInUp(staggerElem, item);
  });

  let slideInUp = document.querySelectorAll("[data-animate-slideinup]");

  slideInUp.forEach(function (item, index) {
    item.style.overflow = "hidden";
    item.innerHTML =
      '<span class="block" data-animate-elm>' + item.textContent + "</span>";
    animation.slideInUp(item.querySelector("[data-animate-elm]"));
  });
  
  let fadeInUp = document.querySelectorAll("[data-animate-fadeinup]");

  fadeInUp.forEach(function (item, index) {
    animation.fadeInUp(item);
  });
}

// 2.0 update on mouse over add class fade now controlled by CSS
// let altImage = document.querySelectorAll('.productItem__imageWrapper--withAlternateImage');
// altImage.forEach((item)=>{
//   item.addEventListener("mouseenter", function() {
//       item.querySelector(".animate_img").classList.add("image--fadeIn");
//     });
//   item.addEventListener("mouseout", function() {
//       item.querySelector(".animate_img").classList.remove("image--fadeIn");
//   });
// },false)